import { ProductRecord } from "../utils/types";
import Autocomplete from "./library/Autocomplete";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAndroid, faApple, faChrome } from '@fortawesome/free-brands-svg-icons';
import { checkForMatch } from "../utils/misc";
import { faImage } from "@fortawesome/free-regular-svg-icons";
import { Menu, MenuItem, Option, TypeaheadLabelKey } from "react-bootstrap-typeahead";
import { Fragment, useState } from "react";
import './ProductsAutocomplete.css';
import { isAllowedFilterField } from "../utils/UserHelper";

function ProductsAutocomplete(props: any) {
  const emptyProductIconEl = <FontAwesomeIcon icon={faImage} fixedWidth></FontAwesomeIcon>;
  const [newSelectionPrefix, setNewSelectionPrefix] = useState(
    renderMenuItemChildrenElement(emptyProductIconEl, null, "unknown product", null, "#03a1fc", "#ccc")
  );

  const iconSize = 30;
  function buildIconCDN(iconURL: string): string {
    // TODO: move this to configuration level
    const CDN_URL = "https://s{INDEX}.api.apptap.com/img/{URL_NO_SCHEME}?s={SIZE}";

    const index = 1+Math.floor(Math.random()*3); // 1-4
    return CDN_URL.replace("{INDEX}", index.toString()).replace("{SIZE}", iconSize.toString()).replace("{URL_NO_SCHEME}", iconURL.substring(7));
  }

  /**
   * Custom renderMenuItem to allow for custom padding on the menu items (less padding),
   * while still retaining the default pagination behavior. 
   * This really should be abstracted into Autocomplete.jsx, but right now it's tied to the
   * data-types for this particular implementation.
   */
   const renderMenuItem = (option: Option, position: number) => {

    const menuItemProps = {
      disabled: !!(option as any)['disabled'],
      option,
      position,
    };

    if ( (option as any)['paginationOption'] ) {
      return (
        <Fragment key="pagination-option-divider">
          <Menu.Divider />
          <MenuItem
            {...menuItemProps}
            className="rbt-menu-pagination-option"
            label={
              "More"
            }>
            "More"
          </MenuItem>
        </Fragment>
      );
    }

    return (
      <MenuItem {...menuItemProps} key={position} style={{paddingLeft: "1em", paddingRight: "1em"}}>
        {renderMenuItemChildren((option as ProductRecord), props, position)}
      </MenuItem>
    );
  };  

  function renderMenuItemChildrenElement(productIconEl:any, platformIcon:any, productName:string, productId:string, iconColor:string, productNameColor:string ) {
    return (
      <span style={{display: "flex", flexDirection: "row", flexWrap: "nowrap", width: "100%"}}>
        <div style={{display: "flex", flexDirection: "row", flexWrap: "nowrap", width: "6em"}}>
          <div style={{flexShrink: 0, width: "30px", textAlign: "center", color: "#ccc"}}>{productIconEl}</div>
          <div style={{flexShrink: 0, width: "1.5em", textAlign: "center", color: iconColor, fontSize: "120%"}}>{platformIcon}</div>
        </div>
        <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap", width: "100%"}}>
          <div style={{flexShrink: 1, flexGrow: 1, width: "20%", minWidth: "10em", overflow: "hidden", whiteSpace: "normal", textOverflow: "ellipsis", marginRight: "5px", color: productNameColor, 
                      WebkitLineClamp: 2, WebkitBoxOrient: "vertical", display: "-webkit-inline-box"}}>{productName}</div>
          <div style={{flexShrink: 1, flexGrow: 1, width: "20%",  minWidth: "10em", overflow: "hidden", textOverflow: "ellipsis"}}>{productId}</div>
        </div>
      </span>
    );
  }
      
  const renderMenuItemChildren = function (product: ProductRecord , obj : any, index : number) {
    let platformIcon:any = null;
    let iconColor:string = null;
    switch ( product.productPlatform ) {
      case "ios": 
       platformIcon = <FontAwesomeIcon icon={faApple} fixedWidth></FontAwesomeIcon>; 
       iconColor = "#7d7d7d";
        break;
      case "android":  
       platformIcon = <FontAwesomeIcon icon={faAndroid} fixedWidth></FontAwesomeIcon>;
       iconColor = "#a4c639"
        break;
      case "web": 
        platformIcon = <FontAwesomeIcon icon={faChrome} fixedWidth></FontAwesomeIcon>; 
        iconColor = "#03a1fc";
        break;
    }

    let productIconEl:any = null;
    if ( product.icon ) {
      productIconEl = <img src={buildIconCDN(product.icon)} width={iconSize} height={iconSize} alt={product.productName}></img>
    } else {
      productIconEl = emptyProductIconEl;
    }

    let productName = product.productName;
    let productNameColor:string = "";
    if ( productName == null ) {
      productName = "no product name";
      productNameColor = "#ccc";
    }

    return renderMenuItemChildrenElement(productIconEl, platformIcon, productName, product.productId, iconColor, productNameColor);
  }

  const filterBy = function(product: ProductRecord, props: any) {
    if ( props.text == null || props.text.length === 0 ) return true;

    const searchString = (props.text as string).trim().toLowerCase();
    const searchStrings:string[] = searchString.split(" ");

    const text = [
      product.productId, product.productName == null ? "" : product.productName, product.productPlatform
    ].join(" ").toLowerCase();

    return checkForMatch(searchStrings, text);
  }

  const onInputChange = (searchString:any) => {
    setNewSelectionPrefix(
      renderMenuItemChildrenElement(emptyProductIconEl, null, "unknown product", searchString, "#03a1fc", "#ccc")
    );
  }

  return <Autocomplete 
            id="productsAutocomplete"
            allowNew
            newSelectionPrefix={newSelectionPrefix}
            placeholder="Products" 
            reactKey="productsAutocomplete"
            onChange={props.onChange} 
            onInputChange={onInputChange}
            options={props.options} 
            selected={props.selected}
            labelKey={'productId' as TypeaheadLabelKey<string>}
            renderMenuItem={renderMenuItem}
            renderMenuItemChildren={renderMenuItemChildren}
            reactRef={props.reactRef}
            filterBy={filterBy}
            maxResults={10}
            disabled={props.disabled}
            useIncludeExclude={isAllowedFilterField("productIdsExclude")}
            defaultIncludeExclude={props.defaultIncludeExclude}
            includeExcludeOnChange={props.includeExcludeOnChange}
            multiple
          />;  
}

export default ProductsAutocomplete;
